import styled from "@emotion/styled";
import { PDPHeadlineTypography } from "../../../../layouts/product-detail-page-layout/pdp-headline-typography";

export const ImageCarouselComponentHeadline = styled.h4`
  ${PDPHeadlineTypography};

  margin-top: 0;
  margin-bottom: 20px;

  &.centered {
    text-align: center;
  }
`;
